import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Modal } from "antd";

export default function CustomModal({
  isCustomModalOpen,
  title = "It is Title Text",
  subTitle = "It is Sub Title Text",
  isClosable = true,
  onOk = () => {},
  onCancel = () => {},
  okText = "Ok",
  cancelText = "Cancel",
  footerCustomButtons = [],
  width = '',
  children,
}) {
  
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
          Modal: {
            titleColor: "#572D86",
            titleFontSize: 20,
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        title={title}
        open={isCustomModalOpen}
        onOk={onOk}
        onCancel={onCancel}
        closable={isClosable}
        okText={okText}
        cancelText={cancelText}
        footer={null}
        okButtonProps={{
          style: {
            backgroundColor: "#FCBD10",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        width={width ? width : ''}

      >
        <div className="text-xl py-2">{subTitle}</div>
        {children}
        <div className="flex justify-end items-center gap-4">
          {okText && (
            <Button key="ok" type="primary" onClick={onOk}>
              {okText}
            </Button>
          )}
          {cancelText && (
            <Button key="cancel" onClick={onCancel}>
              {cancelText}
            </Button>
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
}
